import { RestApiDataService } from '@/services/api/RestApiDataService'

const BASE_ENTITY_URL = '/collections'

class CollectionDataService extends RestApiDataService {

}

export default new CollectionDataService(BASE_ENTITY_URL)
